export interface INotification {
  NotificationType: string;
  UserId: string;
  ContractId: string;
  ContractNumber: string;
}

export interface INotificationType {
  Notification: NotificationType;
  Count: number;
}

export interface INotificationStage {
  label?: string;
  stage?: StageNotification;
  badgeNumber: number | string;
}

export enum NotificationTypeEnum {
  CancelContract = 'CancelContract',
  CancelCompany = 'CancelCompany',
  Notification = 'Notification',
  CancelContractList = 'CancelContractList',
  CancelCompanyList = 'CancelCompanyList'
}

export type NotificationType = 'CancelContract' | 'CancelCompany' | 'Notification' | 'CancelContractList' | 'CancelCompanyList';

export enum StageNotificationEnum {
  Open = 'open',
  Close = 'close'
}

export type StageNotification = 'open' | 'close';
